var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { Popconfirm } from 'antd';
import { Label } from 'pages/Ticket/styled';
import { ErrorMessage } from 'pages/Ticket/components/styled';
import { Select } from 'ui/styled';
import { BLUE } from 'ui/constants';
import { useActiveTicketTypes } from './useActiveTicketTypes';
var ActiveTicketTypeSelect = function (_a) {
    var value = _a.value, onChange = _a.onChange, _b = _a.label, label = _b === void 0 ? '' : _b, _c = _a.showAny, showAny = _c === void 0 ? false : _c, _d = _a.allowClear, allowClear = _d === void 0 ? false : _d, _e = _a.disabled, disabled = _e === void 0 ? false : _e, _f = _a.disabledOptions, disabledOptions = _f === void 0 ? [] : _f, _g = _a.subjectError, subjectError = _g === void 0 ? false : _g, _h = _a.defaultValue, defaultValue = _h === void 0 ? [] : _h, _j = _a.placeholder, placeholder = _j === void 0 ? 'Select ticket type' : _j, _k = _a.noMargin, noMargin = _k === void 0 ? false : _k, _l = _a.isBulkCreateOnly, isBulkCreateOnly = _l === void 0 ? false : _l, ticketType = _a.ticketType, shouldConfirmTypeChange = _a.shouldConfirmTypeChange, rest = __rest(_a, ["value", "onChange", "label", "showAny", "allowClear", "disabled", "disabledOptions", "subjectError", "defaultValue", "placeholder", "noMargin", "isBulkCreateOnly", "ticketType", "shouldConfirmTypeChange"]);
    var _m = useState(false), popupOpen = _m[0], setPopupOpen = _m[1];
    var _o = useState(null), pendingValue = _o[0], setPendingValue = _o[1];
    var _p = useState(Date.now().toString()), selectKey = _p[0], setSelectKey = _p[1];
    var _q = useActiveTicketTypes({
        isBulkCreateOnly: isBulkCreateOnly,
        disabledOptions: disabledOptions,
        ticketType: ticketType,
        showAny: showAny
    }), options = _q.options, loading = _q.loading;
    var handleChange = function (v, option) {
        if (shouldConfirmTypeChange === null || shouldConfirmTypeChange === void 0 ? void 0 : shouldConfirmTypeChange(option === null || option === void 0 ? void 0 : option.surveyId, option === null || option === void 0 ? void 0 : option.enableSurveys)) {
            setPendingValue(v);
            setPopupOpen(true);
        }
        else {
            onChange(v);
        }
    };
    var handleConfirm = function () {
        setPopupOpen(false);
        if (pendingValue !== null)
            onChange(pendingValue);
        setPendingValue(null);
    };
    var handleCancel = function () {
        setPopupOpen(false);
        setPendingValue(null);
        setSelectKey(Date.now().toString());
    };
    return (_jsxs(_Fragment, { children: [label && _jsx(Label, { noMargin: noMargin, children: label }), subjectError && (_jsx(ErrorMessage, { children: "Ticket subject cannot be left as 'Triage'" })), _jsx(Popconfirm, { title: "The Questionnaire responses may be erased. Are you sure you want to change the ticket subject?", open: popupOpen, onConfirm: handleConfirm, onCancel: handleCancel, okButtonProps: {
                    style: { background: BLUE, border: BLUE, borderRadius: 6 }
                }, cancelButtonProps: { style: { borderRadius: 6 } }, children: _jsx(Select, __assign({ placeholder: placeholder, value: value || defaultValue, onChange: handleChange, disabled: disabled, allowClear: allowClear, popupMatchSelectWidth: false, className: subjectError && 'has-error', "data-test": "selectTicketTypeDropdown", options: options, loading: loading, showSearch: { optionFilterProp: 'label' } }, rest), selectKey) })] }));
};
export default ActiveTicketTypeSelect;
